import { AxiosResponse } from 'axios';

import { api } from '../../http';
import type { PersonAssignmentHistoryItem } from '../../pages/personAssignmentHistory/model/types';
import { BaseFilter, PageRequest } from '../../types/interfaces';
import { PageResponse } from '../../types/interfaces/PageResponse';

import { ApiResponse } from './interfaces';

export type PersonAssignmentHistoryParams = PageRequest & {
  sortBy?: string;
  sortDirection?: string;
  parsedFilters?: BaseFilter[];
  fillers?: string;
};

export const PersonAssignmentHistoryService = {
  getHistory(
    params: PersonAssignmentHistoryParams
  ): Promise<
    AxiosResponse<ApiResponse<PageResponse<PersonAssignmentHistoryItem>>>
  > {
    const searchParams = new URLSearchParams();
    Object.keys(params).forEach((key) => {
      const value = (params as Record<string, unknown>)[key];
      if (value !== undefined && value !== null && value !== '') {
        searchParams.append(key, String(value));
      }
    });

    return api.get<ApiResponse<PageResponse<PersonAssignmentHistoryItem>>>(
      'PersonAssignmentHistory',
      {
        params: searchParams
      }
    );
  }
};
